"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LONG_RUNNING_EXPORT_TYPES = exports.FAST_EXPORT_TYPES = void 0;
exports.isExportType = isExportType;
exports.isFastExportType = isFastExportType;
exports.isLongRunningExportType = isLongRunningExportType;
exports.FAST_EXPORT_TYPES = new Set(['KML', 'JSON']);
exports.LONG_RUNNING_EXPORT_TYPES = new Set([
    'EXCEL',
    'OCALC',
    'SPIDACALC',
    'IMAGE_ZIP',
    'POLEFOREMAN',
    'IKE_POLEFOREMAN',
    'IMPORTABLE_EXCEL',
    'DDS',
]);
function isExportType(type) {
    return isFastExportType(type) || isLongRunningExportType(type);
}
function isFastExportType(type) {
    return exports.FAST_EXPORT_TYPES.has(type);
}
function isLongRunningExportType(type) {
    return exports.LONG_RUNNING_EXPORT_TYPES.has(type);
}
//# sourceMappingURL=export.js.map